import React from 'react';
import { FileText, Sparkles } from 'lucide-react';
import { TaskyButton, TaskyTabs, type TaskyTabItem } from '../tasky';
import type { ProductSelectionData } from './ProductSelectionModal';

export type GenerationInputMode = 'product' | 'freetext';

interface GenerationInputModeTabsProps {
  value: GenerationInputMode;
  onChange: (mode: GenerationInputMode) => void;
  disabled?: boolean;
}

export const GenerationInputModeTabs: React.FC<GenerationInputModeTabsProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const items: TaskyTabItem<GenerationInputMode>[] = [
    {
      value: 'product',
      label: '商品から生成',
      icon: <Sparkles className="w-4 h-4" />,
      disabled,
    },
    {
      value: 'freetext',
      label: 'フリーテキスト',
      icon: <FileText className="w-4 h-4" />,
      disabled,
    },
  ];

  return (
    <div className="overflow-x-auto">
      <TaskyTabs<GenerationInputMode>
        items={items}
        value={value}
        onChange={onChange}
        aria-label="生成方法"
        className="w-full min-w-max"
      />
    </div>
  );
};
interface ProductGenerationPanelProps {
  selectedProductData: ProductSelectionData | null;
  additionalInstructions: string;
  onAdditionalInstructionsChange: (value: string) => void;
  onSelectProduct: () => void;
  disabled?: boolean;
}

export const ProductGenerationPanel: React.FC<ProductGenerationPanelProps> = ({
  selectedProductData,
  additionalInstructions,
  onAdditionalInstructionsChange,
  onSelectProduct,
  disabled = false,
}) => (
  <div className="bg-gradient-to-r from-orange-50 to-amber-50 border border-orange-200 rounded-lg p-3">
    <div className="flex items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-2">
        <FileText className="w-4 h-4 text-orange-600 flex-shrink-0" />
        <span className="text-sm font-medium text-gray-900">商品情報</span>
        {selectedProductData && (
          <span className="truncate rounded-full bg-green-50 px-2 py-0.5 text-xs text-green-600">
            {selectedProductData.product.name}
          </span>
        )}
      </div>
      <TaskyButton
        type="button"
        size="sm"
        onClick={onSelectProduct}
        disabled={disabled}
        className="flex-shrink-0"
      >
        <Sparkles className="w-3.5 h-3.5" />
        {selectedProductData ? '商品を変更' : '商品を選択'}
      </TaskyButton>
    </div>

    {selectedProductData && (
      <div className="mt-3 border-t border-orange-200 pt-3">
        <label className="mb-1 block text-xs text-gray-600">詳細を指示する（任意）</label>
        <textarea
          placeholder="例: 夏らしい爽やかな雰囲気で、若い女性が使用しているシーンにしてください"
          value={additionalInstructions}
          onChange={(event) => onAdditionalInstructionsChange(event.target.value.slice(0, 500))}
          maxLength={500}
          rows={2}
          disabled={disabled}
          className="w-full resize-none rounded-md border border-warm-border bg-white p-2 text-sm focus:border-primary focus:ring-2 focus:ring-primary disabled:bg-gray-100"
        />
        <div className="mt-1 flex justify-end">
          <span className="text-xs text-gray-400">{additionalInstructions.length}/500</span>
        </div>
      </div>
    )}
  </div>
);
